import { Role } from "../../types/role";

const REGun: Role = {
  primary: [
    "Ballannahme",
    "Passen",
    "Technik",
    "Entscheidungen",
    "Flair",
    "Nervenstaerke",
    "OhneBall",
    "Teamwork",
    "Uebersicht",
  ],
  secondary: ["Dribbling", "Weitschuesse", "Antizipation", "Balance"],
  physis: "mittelfeld",
};

export const REG = {
  REGun,
};
